export class Logman {

	logmanId: number;
	action: string;
}
